


























import Vue, { PropType } from "vue";
export default Vue.extend({
  name: "list-item-file",
  props: {
    icon: {
      type: String,
    },
    title: {
      type: String,
    },
    file: {
      type: Object as PropType<File>,
    },
  },
  methods: {
    async downloadFile(file: File) {
      var fileData = window.URL.createObjectURL(file);
      var fileLink = document.createElement("a");
      fileLink.href = fileData;
      fileLink.setAttribute("download", file.name);
      document.body.appendChild(fileLink);
      fileLink.click();
    },
  },
  computed: {},
});
